import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectDbasListItems} from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';
import * as R from "ramda"
import { selectGatewaysListItems, selectGatewaysQueryItems } from '../../../../../redux/gateways/selector';
import { gateways } from '../../../../../redux/gateways/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { selectnetworksListItems } from '../../../../../redux/networks/selector';
import { networks } from '../../../../../redux/networks/action';
import GatewayComponent from '../components/gateway.component';


const EdgeGateway= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const queryItems = useSelector(selectGatewaysListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
   const domainItems = useSelector(selectDomainsListItems)
   const NetworkItems = useSelector(selectnetworksListItems)
    const dbasItems = useSelector(selectDbasListItems)
      const { id,tenantId} = useParams()
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>([])
 
  const fetchGatewayById= ()=>{
    dispatch(gateways.list({url:`https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/fetch-detail`,entity:'gatewayRegistries',jsonData:{   
        "Context":{},
          "Records": [
          {
                  "GatewayId":Number(id),
                  "TenantId": Number(tenantId)
          }
        ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedGateway({ ...selectedGateway, [fields[0]]: value });
  }
  useEffect(
    () => {
     dispatch(networks.list({
             url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,
             entity: 'networks',
             jsonData: {}
         })).then(()=>{
          
              dispatch(dbas.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/dbas/list`,
                entity: 'dbas',
                jsonData: {
                }
              })) 
      if (Number(id) > 0) {
        fetchGatewayById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items[0])
      }
    },
    [isQuery]
  )
 
// const handleFormSubmit  = async (event: any) => {
//     event.preventDefault();
//     if (parmas?.id > 0) {
//       await dispatch(gateways.resetAction({ actionType: 'update' }))
//      await dispatch(gateways.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/gateways`,entity:'dbass',jsonData:{
          
//     Records: [{
//       selectedGateway
//     }   
//     ]
 
// }})).then(()=>{
//   back()
// })

//     }else{
//       await dispatch(gateways.resetAction({ actionType: 'create' }))
//       await dispatch(gateways.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/gateways`,entity:'dbass',jsonData:{
          
//         Records: [{
//           selectedGateway
//         }   
//         ]
     
    
//   }})).then(()=>{
//     back()
//   })
//     }

//   }

const back=()=>{
  navigate('/gateway/dbn-cloud/gateways')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <GatewayComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedGateway={selectedGateway}
            domainDetails={domainItems?.result?.items}
            networks={NetworkItems?.result?.items}
           back={back}
          //  handleFormSubmit={handleFormSubmit}
           handleFormChange={handleFormChange}
           dbas={dbasItems?.result?.items}
          /> 
    } 
          </>
    )
    
    }
   
    export default EdgeGateway;
